import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import logo from '../images/mb-logo-full.svg';

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: '#2b2d35',
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        margin: `0 auto`,
        padding: 20,
        height: 70,
        maxWidth: 960,
      }}
    >
      <div style={{ display: 'inherit', marginBottom: '-10px' }}>
        <a href="https://mediabay.uz">
          <img src={logo} alt="Mediabay Logo" style={{ width: 'auto', height: 30, margin: 0 }} />
        </a>
      </div>
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            display: 'inherit',
            color: `white`,
            textDecoration: `none`,
            fontSize: 28,
            fontWeight: 300,
            margin: '0 10px',
          }}
        >
          {siteTitle}
        </Link>
      </h1>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
